export const getGenerationHistoryListStyles = (_, { palette = {} } = {}) => ({
  historyListRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    marginTop: 24,
    paddingTop: 16,
    borderTop: '1px solid #DFDFDF',
    overflow: 'hidden',

    '& .history-list-title-container': {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 3,
      alignItems: 'center',

      '& .history-icon': {
        display: 'flex',
        alignItems: 'center',
        width: 16,
        height: 16,
        color: palette.neutralSecondary,
      },
      '& .history-title': {
        marginLeft: 4,
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 600,
        color: palette.neutralSecondary,
      },
    },

    '& .history-list-container': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      '& .right-icon-hint': {
        display: 'inline-block',
        position: 'absolute',
        background: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
        width: 20,
        height: 80,
        right: 32,
      },

      '& .left-icon-hint': {
        display: 'inline-block',
        position: 'absolute',
        background: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
        width: 30,
        height: 80,
        left: 34,
        transform: 'rotate(-180deg)',
      },

      '& .history-list-images-container': {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'hidden',

        '& .history-list-images': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          position: 'relative',
        },
        '& .history-item-root': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 90,
          height: 80,
          borderRadius: 9,
          border: '2px solid white;',

          '&.selected': {
            border: `2px solid ${palette.themePrimary};`,
          },

          '& .history-item': {
            width: 80,
            height: 70,
            overflow: 'hidden',
            borderRadius: 6,

            '& img': {
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            },
          },
        },
      },
    },
  },
});
